import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomCameraCircleIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 93 93" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M46.5 1.5C71.3529 1.5 91.5 21.6471 91.5 46.5C91.5 71.3529 71.3529 91.5 46.5 91.5C21.6471 91.5 1.5 71.3529 1.5 46.5C1.5 21.6471 21.6478 1.5 46.5 1.5Z"
        fill="#fb0d98"
        stroke="white"
        strokeWidth="3"
      />
      <g clipPath={`url(#${uuid}clip0_215:8769)`}>
        <path
          clipRule="evenodd"
          d="M22 37.2059C22 35.5928 22.6424 34.0457 23.7858 32.905C24.9292 31.7644 26.48 31.1235 28.097 31.1235H50.9607C52.4395 31.1234 53.8679 31.6594 54.98 32.6317C56.0921 33.6041 56.8121 34.9466 57.0058 36.4091L66.4866 32.2062C66.9507 31.9999 67.4591 31.9126 67.9656 31.9522C68.472 31.9918 68.9606 32.1571 69.3868 32.433C69.8129 32.7088 70.1633 33.0866 70.4059 33.5319C70.6484 33.9772 70.7756 34.476 70.7758 34.9828V57.6761C70.7754 58.1825 70.6482 58.6808 70.4058 59.1257C70.1633 59.5707 69.8134 59.9482 69.3876 60.224C68.9618 60.4998 68.4738 60.6652 67.9677 60.7051C67.4616 60.7451 66.9536 60.6583 66.4897 60.4527L57.0058 56.2498C56.8121 57.7123 56.0921 59.0547 54.98 60.0271C53.8679 60.9995 52.4395 61.5355 50.9607 61.5353H28.097C26.48 61.5353 24.9292 60.8945 23.7858 59.7538C22.6424 58.6132 22 57.0661 22 55.453V37.2059Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
    </svg>
  )
}
